// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"a1010e38","493":"440a890b","790":"dfd9d988","833":"becc0a58"}[chunkId] + ".chunk.css";
};